import { render, staticRenderFns } from "./EcommerceEducationalPostTable.vue?vue&type=template&id=6a5bde66&scoped=true&"
import script from "./EcommerceEducationalPostTable.vue?vue&type=script&lang=js&"
export * from "./EcommerceEducationalPostTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommerceEducationalPostTable.vue?vue&type=style&index=0&id=6a5bde66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5bde66",
  null
  
)

export default component.exports